import { render, staticRenderFns } from "./cwLeftTwo.vue?vue&type=template&id=1db1a069&scoped=true"
import script from "./cwLeftTwo.vue?vue&type=script&lang=js"
export * from "./cwLeftTwo.vue?vue&type=script&lang=js"
import style0 from "./cwLeftTwo.vue?vue&type=style&index=0&id=1db1a069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db1a069",
  null
  
)

export default component.exports